// Abre el enlace de una campaña de publicidad en una pestaña nueva.
// Solo http(s): el enlace lo carga la plataforma, pero igual no se ejecuta nada raro.

const ES_HTTP = /^https?:\/\//i;

export function abrirEnlaceCampania(url) {
  if (typeof url !== "string" || !ES_HTTP.test(url)) return;
  window.open(url, "_blank", "noopener");
}
